import React, { useState, useEffect } from 'react';
import EdiText from 'react-editext';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

import schoolsService from 'services/schools.service';

import './NotesEditor.scss';

const NotesEditor = ({ currentSchool }) => {
  const [note, setNote] = useState('');

  useEffect(() => {
    setNote(currentSchool?.notes || '');
  }, [currentSchool]);

  const handleSave = async (value) => {
    setNote('Saving...');
    await schoolsService().updateSchool(currentSchool.school_name, {
      ...currentSchool,
      notes: value,
    });
    setNote(value);
  };

  return (
    <div className="notes-container">
      <EdiText
        type="textarea"
        value={note}
        renderValue={(value) => (
          <ReactMarkdown
            className="notes-markdown"
            remarkPlugins={[remarkGfm, remarkBreaks]}
            linkTarget="_blank"
            components={{
              a: ({ node, href, ...props }) => (
                <a
                  {...props}
                  // react-markdown 6 replaces unsafe URLs with this no-op URL.
                  href={href === 'javascript:void(0)' ? undefined : href}
                  rel="noopener noreferrer"
                />
              ),
            }}
          >
            {value || 'No notes yet...'}
          </ReactMarkdown>
        )}
        inputProps={{ 'aria-label': 'Notes', placeholder: 'Write notes…' }}
        hint="Markdown supported: # Heading, **bold**, - list item, [link text](https://example.com)."
        onSave={handleSave}
        editButtonContent="Edit Notes"
        saveButtonContent="Save Notes"
        cancelButtonContent="Cancel"
        saveButtonClassName="btn btn-success"
        editButtonClassName="btn btn-primary"
        cancelButtonClassName="btn btn-danger"
        viewContainerClassName="notes-view"
        editContainerClassName="notes-editor"
      />
    </div>
  );
};

export default NotesEditor;
